/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free BMI calculator plus BMR/daily-calorie and healthy-weight tools. Metric or imperial. Instant results in your browser — no signup.`)
};

const es_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de IMC gratuita más herramientas de BMR/calorías diarias y peso saludable. Métrico o imperial. Resultados instantáneos en tu navegador — sin registro.`)
};

const de_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser BMI-Rechner plus BMR/Tages-Kalorien- und Idealgewichts-Tools. Metrisch oder Imperial. Sofortige Ergebnisse in Ihrem Browser — keine Anmeldung erforderlich.`)
};

const nl_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis BMI-rekenmachine plus BMR/dagelijkse calorieën en gezonde gewicht tools. Metrisch of imperiaal. Onmiddellijke resultaten in uw browser — geen registratie vereist.`)
};

const fr_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur IMC gratuit plus outils de calcul du BMR/calories quotidiennes et du poids santé. Métrique ou impérial. Résultats instantanés dans votre navigateur — pas d'inscription.`)
};

const it_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore BMI gratuito più strumenti per BMR/calorie giornaliere e peso sano. Metrica o imperiale. Risultati istantanei nel tuo browser — nessuna iscrizione.`)
};

const pt_br2_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora BMI gratuita com ferramentas de BMR/calorias diárias e peso saudável. Métrico ou imperial. Resultados instantâneos no seu navegador — sem cadastro.`)
};

const pt_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de IMC gratuita, mais ferramentas de TMB/calorias diárias e peso saudável. Métrico ou imperial. Resultados instantâneos no seu navegador — sem inscrição.`)
};

const ja_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のBMI計算機、BMR/日次カロリーおよび健康体重ツール。メートル法またはインペリアル法。ブラウザで即座に結果が表示されます—サインアップ不要。`)
};

const zh_bmi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 BMI 计算器，还包含 BMR/每日热量和健康体重工具。支持公制或英制，浏览器内即时出结果——无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_tool_description", locale)
	if (locale === "en") return en_bmi_tool_description(inputs)
	if (locale === "es") return es_bmi_tool_description(inputs)
	if (locale === "de") return de_bmi_tool_description(inputs)
	if (locale === "nl") return nl_bmi_tool_description(inputs)
	if (locale === "fr") return fr_bmi_tool_description(inputs)
	if (locale === "it") return it_bmi_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_tool_description(inputs)
	if (locale === "pt") return pt_bmi_tool_description(inputs)
	if (locale === "ja") return ja_bmi_tool_description(inputs)
	return zh_bmi_tool_description(inputs)
};